import urls from '../api_urls/competitor'
import { _post } from '@/axios/request'

// 获取competitor列表
export function getTableData (params) {
  return _post(urls.GET_LIST, params)
}

// 新增competitor
export function saveCompetitor (params) {
  return _post(urls.SAVE_COMPETITOR, params)
}

// 获取competitor详情
export function getCompetitorDetail (params) {
  return _post(urls.GET_COMPETITOR_DETAIL, params)
}

// 更新competitor信息
export function updateCompetitor (params) {
  return _post(urls.UPDATE_COMPETITOR, params)
}

// 获取inci列表
export function getInci (params) {
  return _post(urls.GET_INCI, params)
}

// 获取function列表
export function getFormulationFunction (params) {
  return _post(urls.GET_FORMULATION_FUNCTION, params)
}



// WEBPACK FOOTER //
// ./src/axios/api/competitor.js